import { Button, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { SliceComponentProps } from '@prismicio/react';
import React from 'react';
import Link from '../../Link/Link';

const ButtonSlice = (props: ButtonSliceType) => {
  const { slice, index, slices } = props;
  const isLastSlice = index === slices.length - 1;
  return (
    <Flex flexDir={{ base: 'column', lg: 'row' }} gridGap='32px' mt='40px' justify='space-between' pb='40px' borderBottom={!isLastSlice && '1px solid'} borderBottomColor='aliceblue.200'>
      <Heading size='h3' as='h3' fontWeight='700' whiteSpace='nowrap'>
        {slice.primary.button_list_title}
      </Heading>
      <Flex gridGap='20px' maxW='744px' w='100%' flexWrap='wrap' mr={{base: '0', lg: '32px'}}>
        {slice.items.map((item, index) => (
          <Flex key={index}>
            <Link to={item.button_url}>
              <Button variant='mediumHollow' h='100%' p='8px 16px'>
                <Flex align='center' gridGap='4px'>
                  <Image
                    src={item.button_icon.url}
                    alt={item.button_icon.alt}
                    maxW='32px'
                    w='100%'

                  />
                  <Text fontSize='14px' color='grey.700'>{item.button_label}</Text>
                </Flex>
              </Button>
            </Link>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export type ButtonSliceType = SliceComponentProps<{
  id: string;
  items: {
    button_icon: {
      url?: string;
      alt?: string;
    };
    button_label?: string;
    button_url?: string;
  }[];
  primary: {
    button_list_title?: string;
  };
  slice_type: string;
}>;

export default ButtonSlice;
